/* eslint-disable */

import store from '../store';
import { HTTP_HYPER_ESPACE_BACKEND } from "@/services/http-common";

const axios = require("axios");

/**
 * @returns {object}
 */
export async function recordToken(token, utilisateur, api, dateCreation, dateExpiration) {
    if (!utilisateur) {
        utilisateur = store.getters.getSitimmoUser.login
    }
    if (!api) {
        api = "META"
    }
    let params = {
        token: token,
        utilisateur: utilisateur,
        api: api,
        date_creation: dateCreation,
        date_expiration: dateExpiration
    }
    return HTTP_HYPER_ESPACE_BACKEND
        .post('/create_token_utilisateur_api', params)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return error;
        });
}

export async function getTokenUtilisateur(api) {
    const params = { params: {utilisateur: store.getters.getSitimmoUser.login, api: api} }
    const tokenUtilisateur = HTTP_HYPER_ESPACE_BACKEND.get('/token_utilisateur_api', params).then(response => {
        return response.data._embedded.token_utilisateur_api[0]
    }).catch(error => {
        console.log('token_utilisateur_api: ' + error)
    })
    return tokenUtilisateur
}

export async function issetTokenUtilisateur() {
    const params = { params: {utilisateur: store.getters.getSitimmoUser.login, api: "META"} }
    const issetTokenUtilisateur = HTTP_HYPER_ESPACE_BACKEND.get('/isset_token_utilisateur_api', params).then(response => {
        return response.data
    }).catch(error => {
        console.log('issetTokenUtilisateur: ' + error)
    })
    return issetTokenUtilisateur
}

/**
 * @returns {Promise<unknown>}
 */
export function validToken() {
    const params = { params: { utilisateur: store.getters.getSitimmoUser.login, api: "META" } }
    let valid = false
    return HTTP_HYPER_ESPACE_BACKEND.get('/token_utilisateur_api', params).then(response => {
        const tokenUtilisateur = response.data._embedded.token_utilisateur_api[0]
        if (tokenUtilisateur) {
            if (new Date() < new Date(tokenUtilisateur.date_expiration)) {
                if (tokenUtilisateur.token) {
                    const urlTokenAdmin = 'https://graph.facebook.com/oauth/access_token?grant_type=client_credentials&client_id=811967143434375&client_secret=5bffb130720f35ecc6cbb31a053808f9'
                    return axios.get(urlTokenAdmin, {}).then((response) => {
                        if (response && response.data && response.data.access_token) {
                            window.FB.api('/debug_token?input_token=' + tokenUtilisateur.token + '&access_token=' + response.data.access_token, function (response) {
                                if (response && response.data) {
                                    valid = (response.data.is_valid == true)
                                }
                            })
                        }
                    }).catch(error => {
                        return { type: 'error', message: error }
                    })
                }
            }
        }
        return valid
    }).catch(error => {
        return valid
    })
}

/**
 * @param userId
 * @param pageId
 * @returns {Promise<unknown>}
 */
export function recordDiffusionsMeta (userIdFacebook, userIdInstagram, pageId) {
    const params = { userIdFacebook: userIdFacebook, userIdInstagram: userIdInstagram, pageId: pageId }
    return HTTP_HYPER_ESPACE_BACKEND.post('/diffusion_annonceur_meta', params).then(response => {})
    .catch(error => {
        console.log(error)
    })
}

/**
 * @returns {Promise<T | void>}
 */
export function disconnectFacebook () {
    const params = { utilisateur: store.getters.getSitimmoUser.login, api: "META" }
    return HTTP_HYPER_ESPACE_BACKEND.post('/disconnect_facebook', params).then(response => {})
        .catch(error => {
            console.log(error)
        })
}

export function recordDiffusionsGoogle (location) {
    const params = { location: location }
    return HTTP_HYPER_ESPACE_BACKEND.post('/diffusion_annonceur_google', params).then(response => {})
        .catch(error => {
            console.log(error)
        })
}
